import clone from 'shadow-fns/src/clone'
import isObject from './isObject'
import hasOwn from './hasOwn'
import select from './select'
import reject from './reject'

const foreignProps = (component, options) => {
  let { only, except, defaults } = Object(options)

  let props = clone(component.props)
  let fetch = val => val

  if (isObject(props)) {
    if (only)
      props = select(props, prop => only.includes(prop))

    if (except)
      props = reject(props, prop => except.includes(prop))

    if (defaults) {
      Object.keys(defaults).forEach(prop => {
        if (hasOwn(props, prop)) {
          props[prop]['default'] = defaults[prop]
        }
      })
    }

    fetch = val => select(val, prop => hasOwn(props, prop))
  }

  return { props, fetch, names: Object.keys(props) }
}

export default foreignProps
